import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'

import { doSignout } from '../../Utils/api'

import BG from '../../Images/dynamic-dash-bg3.svg'
import { Flex, FlexColumn } from '../Reusable/Container'
import UserWelcome from './Cards/UserWelcome'
import RecentTxns from './Cards/RecentTxns'

import ARAging from './Cards/ARAging'
import CreditFunds from './Cards/CreditFunds'
import CardSpend from './Cards/CardSpend'
import BillsInbox from './Cards/BillsInbox'
import Apps from './Cards/Apps'
import Approvals from './Cards/Approvals'
import { getFeaturePerm, getUserApps, isMobile, getBPAccountsWithAccess, isAnyAccountLockedOrClosed } from '../../Utils/util'
import ExtAccounts from './Cards/ExtAccounts'

import { Text, Tag } from '../Reusable/Text'
import { Image } from '../Reusable/Image'
import { Button } from '../Reusable/Button'
import ModalClose from '../../Images/modal-close.png'
import FullScreenModal from '../Reusable/FullScreenModal'
import { StyledExtLink, StyledLink } from '../Reusable/Link'
import Lock from '../../Images/lock-locked.svg'
import AionText from "../../Images/aion-logo-text.png"

const AnimatedBG = styled(FlexColumn)`
    background-image: url(${props => props.bgImage});
    background-size: cover;
    background-attachment: fixed;
    min-height: 100vh;
    width: 100%;
    overflow-y: auto;
`

class Index extends Component {
    state = {
    }

    componentDidMount() {
        var Accounts = getBPAccountsWithAccess("Transactions", { getActiveAccounts: false })
        Accounts = Accounts || []

        if (isAnyAccountLockedOrClosed(Accounts)) this.props.history.push('/frozen-account')
    }

    signout = () => {
        this.props.doSignout(this.props.history);
    }

    render() {
        const { store } = this.props;
        const { } = this.state;
        const { showFrozenAccountModal } = this.state
        const fontSize = "18px"
        const showCreditPlus = getFeaturePerm("AionApplications.Onboarding.CreditPlus").view;

        const allowedApps = getUserApps(store);
        const arCreditApp = allowedApps.includes("ARCredit");
        const ablCreditApp = allowedApps.includes("ABLCredit");
        const tlCreditApp = allowedApps.includes("TermLoans");

        const creditEnabled = (arCreditApp || ablCreditApp || tlCreditApp);

        var widgets = [
            <UserWelcome />,
            <RecentTxns />,
            <ExtAccounts />,
            <Apps />,
        ];

        if (creditEnabled || showCreditPlus) {
            widgets = widgets.concat([
                <CreditFunds />,
                <ARAging />,
                <CardSpend />,
                <BillsInbox />,
                <Approvals />,

            ]);
        } else {
            // Default
            widgets = widgets.concat([
                <BillsInbox />,
                <CardSpend />,
                <ARAging />,
                <Approvals />,
            ]);
        }

        const isSmall = (n) => {
            /**
             * Follows the pattern to indicate small card for 0, 3, 4, 7, 8, 11, 12, ...
             * Return true for index 0
             * For all other indices, it groups them into sets of 4 (after subtracting 1 to account for the special case of 0)
             * Within each group of 4, the last 2 positions are small cards
             */
            if (n === 0) return true;
            return ((n - 1) % 4) >= 2;
        };

        return (
            <AnimatedBG start centerHorizontally bgImage={BG} style={{ padding: '20px 80px' }}>
                <Flex start centerVertically style={{ padding: '40px 80px', maxWidth: '1400px' }} gap='32px' wrap>
                    {
                        widgets.map((w, i) => {
                            const smallCard = isMobile || isSmall(i);
                            console.log("isSmall", i, smallCard);
                            return React.cloneElement(w, {
                                key: i,
                                small: smallCard
                            })
                        })
                    }
                </Flex>
            </AnimatedBG>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        doSignout: (history) => dispatch(doSignout(history))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))